import * as React from 'react'

const SESSION_STORAGE_KEY = 'childPageVisited'

export function useClearHashOnReturn() {
  React.useLayoutEffect(() => {
    // Remove hash from URL only when returning from a child page
    if (window.location.hash && sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      // Immediately scroll to top to prevent hash-based auto-scrolling
      window.scrollTo(0, 0);
      // Clear the flag after using it
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  }, [])
}
